import { useState, useEffect } from "preact/hooks";

const useAsync = (f, deps) => {
  const [result, setResult] = useState();
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let subscribed = true;
    setIsLoading(true);

    f().then(
      (r) => {
        if (subscribed) {
          setIsLoading(false);
          setResult(r);
        }
      },
      (e) => {
        if (subscribed) {
          setIsLoading(false);
          setError(e);
        }
      }
    );

    return function cleanup() {
      subscribed = false;
    };
  }, deps || []);

  return [result, error, isLoading];
};

export default useAsync;
